import React, { useState } from "react";
import homedata from "../../data/home.json";
import axios from "axios";
import Swal from "sweetalert2";
import ReactLoading from "react-loading";
import WhatsAppIcons from "./whatsapp";

const serviceAreas = [
  { name: "Oklahoma City", top: "43%", left: "73%" },
  { name: "Edmond", top: "18%", left: "68%" },
  { name: "Norman", top: "78%", left: "72%" },
  { name: "Moore", top: "69%", left: "76%" },
  { name: "Guthrie", top: "12%", left: "60%" },
  { name: "Arcadia", top: "30%", left: "80%" },
  { name: "Yukon", top: "34%", left: "46%" },
  { name: "Mustang", top: "66%", left: "50%" },
  { name: "Del City", top: "52%", left: "82%" },
  { name: "Midwest City", top: "48%", left: "87%" },
  { name: "Oklahoma City Metro Area", top: "48%", left: "70%" },
];

const Contact = () => {
  const [cargando, setCargando] = useState(false);

  const envioDeCorreo = (e) => {
    e.preventDefault();

    const form = e.target.closest("form");

    const nombre = form.name.value;
    const correo = form.email.value;
    const telefono = form.phone.value;
    const direccion = form.address.value;
    const interesado = form.interested.value;

    const mensaje = `
Name: ${nombre}
E-mail: ${correo}
Phone: ${telefono}
Address: ${direccion}
Interested in: ${interesado}
    `.trim();

    const nombreProp = "John 316 Painting";
    const correoProp = "contact@john316painting.com";
    const pagina = "john316painting.com";

    const data = {
      nombre,
      correo,
      mensaje,
      nombreProp,
      correoProp,
      pagina,
    };

    setCargando(true);

    axios
      .post("https://taeconta.com/api/public/api/correos/publicos", data)
      .then((response) => {
        console.log("Correo enviado con éxito:", response.data);

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Message sent successfully",
          showConfirmButton: false,
          timer: 1500,
        });

        form.reset();
        setCargando(false);
      })
      .catch((error) => {
        console.error("Error al enviar el correo:", error);

        Swal.fire(
          "Error sending message",
          `${error.message}${
            error.response?.data?.message
              ? ", " + error.response.data.message
              : ""
          }`,
          "error",
        );

        setCargando(false);
      });
  };

  const contactInfo = homedata.contact;
  const sectionHeadingInfo = contactInfo.sectionHeading;
  const publicUrl = process.env.PUBLIC_URL;

  const inlineStyle = {
    backgroundImage: "url(" + publicUrl + contactInfo.bgImg + ")",
  };

  return (
    <section
      id="contact"
      className="pt100 pb100 bg-parallax"
      style={inlineStyle}
    >
      <WhatsAppIcons />

      <div className="color-overlay opacity-8"></div>

      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="contact-block text-center">
              <div className="col-sm-12">
                <h3>{sectionHeadingInfo.title}</h3>
                <p className="subtitle">{sectionHeadingInfo.desc}</p>
              </div>

              <form id="contact-form">
                <div className="row">
                  <div className="col-sm-12">
                    <input
                      name="name"
                      className="contact-name form-control input-box"
                      id="contact-name"
                      type="text"
                      placeholder="Name"
                      required
                    />
                  </div>

                  <div className="col-sm-12">
                    <input
                      name="email"
                      className="contact-email form-control input-box"
                      id="contact-email"
                      type="email"
                      placeholder="E-mail"
                      required
                    />
                  </div>

                  <div className="col-sm-12">
                    <input
                      name="phone"
                      className="contact-phone form-control input-box"
                      id="contact-phone"
                      type="tel"
                      placeholder="Phone"
                      required
                    />
                  </div>

                  <div className="col-sm-12">
                    <input
                      name="address"
                      className="contact-address form-control input-box"
                      id="contact-address"
                      type="text"
                      placeholder="Address"
                      required
                    />
                  </div>

                  <div className="col-sm-12">
                    <label
                      htmlFor="contact-interested"
                      style={{
                        display: "block",
                        textAlign: "center",
                        marginBottom: "20px",
                        color: "#667792",
                        fontSize: "20px",
                        fontWeight: 400,
                      }}
                    >
                      Interested in:
                    </label>

                    <select
                      name="interested"
                      className="contact-interested form-control input-box"
                      id="contact-interested"
                      required
                      defaultValue=""
                    >
                      <option value="" disabled>
                        Select an option
                      </option>
                      <option value="Interior">Interior</option>
                      <option value="Exterior">Exterior</option>
                      <option value="Cabinets">Cabinets</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  <div className="col-sm-12">
                    <button
                      type="submit"
                      className="primary-btn"
                      onClick={envioDeCorreo}
                      disabled={cargando}
                    >
                      {cargando ? (
                        <ReactLoading type="cylon" />
                      ) : (
                        <>
                          <i
                            className="fa fa-paper-plane"
                            aria-hidden="true"
                          ></i>{" "}
                          {contactInfo.submitBtnLabel}
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </form>

              <div className="col-lg-8 offset-lg-2 mt-5">
                <h3>Hours of Operation</h3>
                <p>Monday – Friday: 8:00 AM – 6:00 PM</p>
                <p>Saturday: 8:00 AM – 1:00 PM</p>
              </div>
            </div>

            <div className="contact-block text-center">
              <h3>Service Areas</h3>

              <p style={{ color: "#555", marginBottom: "25px" }}>
                We proudly serve these communities in the Oklahoma City Metro
                Area.
              </p>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "12px",
                  marginBottom: "28px",
                }}
              >
                {serviceAreas.map((area) => (
                  <a
                    key={area.name}
                    href={`https://www.google.com/maps/search/${encodeURIComponent(
                      area.name + ", Oklahoma",
                    )}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      background: "#ffffff",
                      color: "#0d3559",
                      padding: "13px 22px",
                      borderRadius: "8px",
                      fontWeight: 600,
                      boxShadow: "0 8px 22px rgba(13, 53, 89, 0.12)",
                      border: "1px solid rgba(13, 53, 89, 0.12)",
                      textDecoration: "none",
                    }}
                  >
                    {area.name}
                  </a>
                ))}
              </div>

              <div
                style={{
                  position: "relative",
                  overflow: "hidden",
                  borderRadius: "8px",
                  boxShadow: "0 18px 45px rgba(0, 0, 0, 0.18)",
                  background: "#fff",
                }}
              >
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3334017.5563579523!2d-98.71671339999999!3d35.30904955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87ac3911b1ac4f9d%3A0x5d1ccf33400aea48!2sOklahoma%2C%20EE.%20UU.!5e0!3m2!1ses-419!2smx!4v1733785017858!5m2!1ses-419!2smx"
                  width="100%"
                  height="390"
                  style={{ border: "0", display: "block" }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="John 316 Painting Service Areas"
                ></iframe>

                {serviceAreas.map((area, index) => (
                  <a
                    key={area.name}
                    href={`https://www.google.com/maps/search/${encodeURIComponent(
                      area.name + ", Oklahoma",
                    )}`}
                    target="_blank"
                    rel="noreferrer"
                    title={area.name}
                    style={{
                      position: "absolute",
                      top: area.top,
                      left: area.left,
                      transform: "translate(-50%, -100%)",
                      width: "28px",
                      height: "28px",
                      borderRadius: "50% 50% 50% 0",
                      background:
                        index % 4 === 0
                          ? "#e63946"
                          : index % 4 === 1
                            ? "#f59e0b"
                            : index % 4 === 2
                              ? "#0f9f6e"
                              : "#8b4513",
                      rotate: "-45deg",
                      boxShadow: "0 6px 16px rgba(0, 0, 0, 0.35)",
                      border: "3px solid #fff",
                      zIndex: 2,
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: "9px",
                        height: "9px",
                        borderRadius: "50%",
                        background: "#fff",
                        transform: "translate(-50%, -50%)",
                      }}
                    ></span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
